module.exports = __webpack_public_path__ + "img/summary_report.ea3dce64.jpg";